const ReactIntl = require('react-intl');

if (typeof ReactIntl.useIntl !== 'function') {
    ReactIntl.useIntl = () => ({
        formatMessage: (descriptor, values) => {
            const message = descriptor && (descriptor.defaultMessage || descriptor.id) || '';
            if (!values) return message;
            return message.replace(/\{(\w+)\}/g, (match, key) =>
                Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match
            );
        }
    });
}

module.exports = ReactIntl;
